import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { IContact } from "../models/Contact";
import apiConfig from "../utils/apiConfig";

export default function useAccountContacts(accountId?: string, componentName = "useAccountContacts") {
  const { get } = useApiHelper(apiConfig(componentName));

  const accountContacts = useQuery({
    queryKey: ["accounts", accountId, "contacts"],
    queryFn: () =>
      get<DefaultResponseWithData<IContact[]>>(`/account/${accountId}/contacts`),
    enabled: !!accountId,
  });

  return {
    accountContacts,
  };
}
